<script>
import baseMixin from '@/mixins/baseMixin'
import { TimesheetPrimaryGroupingType } from '@/shared/constants/timesheet/TimesheetPrimaryGroupingType'

export default {
  name: 'TimesheetPrimaryGroupingToggle',
  mixins: [baseMixin],
  model: {
    prop: 'toggleValue',
    event: 'toggleUpdated',
  },
  props: {
    toggleValue: {
      type: String,
      required: true,
    },
  },
  data: () => {
    return {
      TimesheetPrimaryGroupingType,
    }
  },
  computed: {
    toggleValueModel: {
      get() {
        return this.toggleValue
      },
      set(value) {
        this.$emit('toggleUpdated', value)
      },
    },
  },
}
</script>

<template>
  <div>
    <v-btn-toggle v-model="toggleValueModel" mandatory>
      <v-btn
        data-testid="timesheet-group-toggle-client"
        :value="TimesheetPrimaryGroupingType.client"
      >
        {{ $t('timesheets.primaryGrouping.clientGroupingToggleText') }}
      </v-btn>
      <v-btn
        data-testid="timesheet-group-toggle-candidate"
        :value="TimesheetPrimaryGroupingType.candidate"
      >
        {{ $t('timesheets.primaryGrouping.candidateGroupingToggleText') }}
      </v-btn>
    </v-btn-toggle>
  </div>
</template>
